import React, { Component } from 'react';
import Truncate from 'react-truncate';
import {withTranslation, WithTranslation} from "react-i18next";

interface StateToProps {
    children: React.ReactNode,
    lines?: number,
    marginTop?: string
}

class _ReadMore extends Component<StateToProps & WithTranslation, any> {

    constructor(props: StateToProps & WithTranslation, context: any) {
        super(props, context);

        this.state = {
            expanded: false,
            truncated: false
        };

        this.handleTruncate = this.handleTruncate.bind(this);
        this.toggleLines = this.toggleLines.bind(this);
    }

    handleTruncate(truncated: boolean) {
        if (this.state.truncated !== truncated) {
            this.setState({
                truncated
            });
        }
    }

    toggleLines() {
        this.setState({
            expanded: !this.state.expanded
        });
    }

    render() {
        const {
            t,
            children,
            lines,
            marginTop
        } = this.props;

        const {
            expanded,
            truncated
        } = this.state;

        return (
            <React.Fragment>
                <div className={truncated&&!expanded?' d-none': marginTop?marginTop:'mt-2'}>
                    <Truncate lines={!expanded && lines}  onTruncate={this.handleTruncate}>
                        {children}
                    </Truncate>
                </div>
                {(truncated || expanded) && (
                    <div className={"action w-100 text-left text-bold-small-details" + (expanded?'':' ' + marginTop?marginTop:'mt-2')}
                         onClick={() => this.toggleLines()}>
                        {this.state.expanded ? t('products.configuration.hidebaseinfo') : t('products.configuration.showbaseinfo')}
                    </div>)
                }
            </React.Fragment>
        );
    }
}

export const ReadMore = withTranslation('common')(_ReadMore);


// WEBPACK FOOTER //
// ./src/fragments/ReadMore.tsx